import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'course-reservations';

export function getSignedStudents(data) {
  return get({
    url: `${url}/signed-students`,
    data,
  });
}

export function getCourseReservationRecordsByStudentId(data) {
  return get({
    url: `${url}/records`,
    data,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

// 设为签到
export function changeToSignedIn(data) {
  return patch({
    url,
    data,
  });
}


// 设为爽约
export function changeToSignBroken(id) {
  return patch({
    url: `${url}/${id}`,
  });
}

// 爽约设为已签到
export function signBrokenToSignedIn(data) {
  return patch({
    url: `${url}/sign-broken-students`,
    data,
  });
}

// 取消预约
export function cancelReserve(id) {
  return del({
    url: `${url}/${id}/reserved-students`,
  });
}

// 取消签到 或 取消试课
export function cancelSignIn(id) {
  return del({
    url: `${url}/${id}/signed-in-students`,
  });
}
